import { useContext } from "react"

// ** React Imports
import { Link, useNavigate } from "react-router-dom"

// ** Custom Components
import Avatar from "@components/avatar"

// ** Third Party Components
import { Power, Lock } from "react-feather"

// ** Reactstrap Imports
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem
} from "reactstrap"

import useApi from '@hooks/useApi'
import useLoader from '@hooks/useLoader'
import { AuthContext } from '@context/AuthContext'

const UserDropdown = () => {
    const { userDetail, isAdmissionUser } = useContext(AuthContext)
    const { fetchData } = useLoader({})

    const userApi = useApi().user
    const admissionUserApi = useApi().admissionuser

    const navigate = useNavigate()

    const logOut = async() => {
        if(isAdmissionUser) {
            // Элсэгч гарах үед
            const { success } = await fetchData(admissionUserApi.logout())
            if(success) {
                navigate('/admission-login')
            }
        } else {
            const { success } = await fetchData(userApi.logout())
            if(success) {
                navigate('/login')
            }
        }
    }

    return (
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
            <DropdownToggle
                href="/"
                tag="a"
                className="nav-link dropdown-user-link"
                onClick={(e) => e.preventDefault()}
            >
                {/* <div className="user-nav d-sm-flex d-none">
                    <span className="user-name fw-bold">{userDetail?.student?.full_name}</span>
                    <span className="user-status">{userDetail?.student?.group?.profession?.name}</span>
                </div> */}
                {
					userDetail != null
                    &&
                    // && userDetail?.image
					// ?
					// 	<Avatar
					// 		img={userDetail?.image}
					// 		imgHeight="40"
					// 		imgWidth="40"
					// 		status="online"
					// 	/>
					// :
						<Avatar
							initials
							color = {'light-success'}
							content = {isAdmissionUser ? userDetail?.first_name : userDetail?.student?.first_name || ''}
							contentStyles = {{
								borderRadius: 0,
							}}
							status="online"
						/>
				}
            </DropdownToggle>
            <DropdownMenu end>
                {
                    !isAdmissionUser &&
                    <DropdownItem tag={Link} to="/change-password">
                        <Lock size={14} className="me-75" />
                        <span className="align-middle">Нууц үг солих</span>
                    </DropdownItem>
                }
                <DropdownItem tag={Link} to="/login" onClick={(e) => logOut()}>
                    <Power size={14} className="me-75" />
                    <span className="align-middle">Гарах</span>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default UserDropdown
